<template>
  <div>
    <div class="founding" v-if="isMobile == 'pc'">
      <div class="founding-img">
        <div class="founding-img-title">
          <h2>{{org.title }}</h2>
        </div>
        <div>
          <img :src="org.imgUrl" alt="" style="width: 100%;" class="organization-img">
        </div>
        <!-- <div class="founding-img-list">
          <div class="founding-img-list-item">
            <img :src="img" alt="" style="width: 100%;">
          </div>
        </div> -->
      </div>
    </div>
    <div class="founding-mobile" v-if="isMobile == 'mobile'">
      <div class="founding-img">
        <div class="founding-img-title">
          <h2>{{org.title }}</h2>
        </div>
        <div>
          <img :src="org.imgUrl" alt="" style="width: 100%;" class="organization-img">
        </div>
        <!-- <div class="founding-img-list">
          <div class="founding-img-list-item">
            <img :src="img" alt="" style="width: 100%;">
          </div>
        </div> -->
      </div>
    </div>
  </div>
  
</template>

<script>
	import { listInfo } from '@/api/index';
export default {
  data() {
    return {
	org:{
		title: '萨马兰奇体育发展基金会组织架构图',
		id: '1',
		imgUrl: '',
		}
    };
  },
  computed: {
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  mounted() {
	  //组织结构图
	this.listCouncil();
  },
  methods: {
	 //组织结构图
	 listCouncil() {
		 const formData = new FormData();
		 formData.append("moduleId", 12);
		 listInfo(formData).then(res => {
		   if (res.data && res.data != null) {
		     this.org = res.data[0];
		   }
		 })
	  },
  }
};
</script>

<style lang="less" scoped>
.founding {
  margin-top: -2rem;
  .founding-img {
    margin: 0 auto;
    width: 90%;
    .founding-img-title {
      margin-top: 5rem;
      text-align: center;
    }
  }
}

.founding-mobile {
  margin-top: -2rem;
  padding: 0 18px;
  .founding-img {
    margin: 0 auto;
    // width: 80%;
    .founding-img-title {
      margin-top: 5rem;
      text-align: center;
    }
  }
}

.organization-img {
  width: 100%;
  margin-top: 2rem;
}
</style>